import React from "react";
import { Box, Fab, Typography } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import SectionFrame from "../SectionFrame";
import { EditableText } from "../InlineEditable";

export default function FloatingWhatsappSection({ form, active, device, onSelect, onCommit, disabled }) {
  const isMobile = device === "mobile";
  const enabled = form.sections.showFloatingWhatsapp !== false;

  return (
    <SectionFrame
      id="floatingWhatsapp"
      label="WhatsApp flotante"
      active={active}
      enabled={enabled}
      onSelect={onSelect}
      onToggle={(next) => onCommit("sections.showFloatingWhatsapp", next)}
      sx={{ minHeight: 118, bgcolor: "rgba(25,36,47,.025)" }}
    >
      <Box sx={{ px: isMobile ? 2.2 : 5.5, py: 3.2, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
        <Box sx={{ maxWidth: 650 }}>
          <Typography sx={{ fontWeight: 950, color: form.theme.secondaryColor || "#19242F" }}>Botón fijo de WhatsApp</Typography>
          <EditableText
            value={form.contact.floatingWhatsappAriaLabel}
            fallback="Contactar por WhatsApp"
            disabled={disabled}
            onSave={(value) => onCommit("contact.floatingWhatsappAriaLabel", value)}
            sx={{ mt: 0.5, color: form.theme.mutedTextColor || "#5B5D73", fontSize: 14 }}
          />
        </Box>
        <Fab size={isMobile ? "medium" : "large"} sx={{ flexShrink: 0, bgcolor: "#25D366", color: "#fff", boxShadow: "0 8px 28px rgba(0,0,0,.3)", "&:hover": { bgcolor: "#1ebe5d" } }}>
          <WhatsAppIcon />
        </Fab>
      </Box>
    </SectionFrame>
  );
}
